import axios from "axios";

const init = () => {
  const baseURL = process.env.NODE_ENV === `production` ? "https://api.mangomint.com/api/v1/" : "/mm-api/v1/";
  return axios.create({
    baseURL,
  });
};

const api = init();

export default {
  signUpPreflight(apiData) {
    return api.post("signup-preflight", apiData);
  },
  signUp(apiData) {
    return api.post("signup", apiData);
  },
};
